export default __webpack_public_path__ + "static/media/WhatsApp Community_Barari.ee6ce8f8.jpeg";